import React from 'react';

const VideoHolder = () => {
  return (
    <>
      <div className='row'>
        <div className='col-md-12 d-flex  justify-content-center ' data-aos='fade-up' data-aos-delay='200'>
          <iframe
            width='560'
            height='315'
            src='https://www.youtube.com/embed/m49aSO8Kih8?si=6mEwzW-0BCCLmwte'
            title='YouTube video player'
            frameborder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            referrerpolicy='strict-origin-when-cross-origin'
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div className='row mt-4 mb-4'></div>
    </>
  );
};

export default VideoHolder;
